import { Component, OnInit } from '@angular/core';
//import { DialogPosition, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { WinoCookieService } from '../../../modules/wino-shared/services/wino-cookie.service';
//import { CookiesDisclaimerDialogComponent } from '../cookies-disclaimer-dialog/cookies-disclaimer-dialog.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(/*private matDialog: MatDialog,*/private readonly cookieService: WinoCookieService) { }

  ngOnInit(): void {
  }

  acceptCookies(result: boolean): void {
    (this.inputValueIsEmpty(result) || result) ? this.cookieService.acceptCookies() : this.cookieService.refuseCookies();
  }
/**********
  openCookiesDialog() {
    const dialogConfig: MatDialogConfig = new MatDialogConfig();
    const dialogPosition: DialogPosition = {bottom: '12px'};
    dialogConfig.maxWidth = "60%";
    dialogConfig.minHeight = "10%";
    dialogConfig.position = dialogPosition;
    //dialogConfig.backdropClass = 'backdropBackground';
    const dialogRef = this.matDialog.open(CookiesDisclaimerDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      let acceptCookies: boolean;
      acceptCookies = result;
      (this.inputValueIsEmpty(acceptCookies) || acceptCookies) ? this.cookieService.acceptCookies() : this.cookieService.refuseCookies();
    });
  }
  *****************************/

  inputValueIsEmpty(value: any): boolean {
    // we don't check for string here so it also works with arrays
    return (value === null || value === undefined || value.length === 0 || value === '' || value === 0);
  }
} 